import React from 'react';
import {Slide, Zoom } from 'react-awesome-reveal'
import AZ from '../../assets/logos/logo2.png'
import { Link } from 'react-router-dom';
const BannerFaq = () => {
  return (
    <div
      id="banner-area"
      className="banner-area"
      style={{ backgroundImage: "url(images/assets/ban6.jpg)", height:'550px' }}
    >
      <div className="banner-text">
        <div className="container">
             <div className="text-center mb-3">
                      <Zoom>
                        <img src={AZ} alt="logo" className="img-fluid mb-3 mt-5" style={{ maxWidth: 300 }} />
                      </Zoom>
                    
                    </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="banner-heading">
                <Zoom>
                <h1 className="banner-title">FAQ</h1>
                </Zoom>  
                <nav aria-label="breadcrumb">
                <Slide direction="left">
                  <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item">
                      <Link to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/Services">Nos Services</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                   FAQ
                    </li>
                  </ol>
                  </Slide>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerFaq;
